import { useState } from "react";
import { useResetPasswordMutation } from "../api/passwordRecoveryApi";
import { getResetPasswordError } from "./getResetPasswordError";

interface UseResetPasswordResult {
  password: string;
  setPassword: (password: string) => void;
  confirmPassword: string;
  setConfirmPassword: (password: string) => void;
  submit: () => void;
  isSubmitting: boolean;
  errorMessage: string | null;
  isSuccess: boolean;
}

export const useResetPassword = (token: string): UseResetPasswordResult => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [mismatchError, setMismatchError] = useState<string | null>(null);
  const [resetPassword, { isLoading, error, isSuccess }] =
    useResetPasswordMutation();

  const submit = async () => {
    if (!password || !confirmPassword) return;
    if (password !== confirmPassword) {
      setMismatchError("Passwords do not match.");
      return;
    }
    setMismatchError(null);
    try {
      await resetPassword({ password, token }).unwrap();
    } catch {
      // error surfaced via mutation state below
    }
  };

  return {
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    submit,
    isSubmitting: isLoading,
    errorMessage: mismatchError ?? getResetPasswordError(error),
    isSuccess,
  };
};
